export enum PmListFilterActionsEnum {
  PM_LIST_FILTER_SET_SWITCHER = 'PM_LIST_FILTER_SET_SWITCHER',
  PM_LIST_FILTER_SET_CURRENT = 'PM_LIST_FILTER_SET_CURRENT',
  PM_LIST_FILTER_SET_PLAN_NUM = 'PM_LIST_FILTER_SET_PLAN_NUM',
  PM_LIST_FILTER_GET_META = 'PM_LIST_FILTER_GET_META',
  PM_LIST_FILTER_SET_META = 'PM_LIST_FILTER_SET_META',
  PM_LIST_FILTER_GET_DATA = 'PM_LIST_FILTER_GET_DATA',
  PM_LIST_FILTER_SET_DATA = 'PM_LIST_FILTER_SET_DATA',
  PM_LIST_FILTER_CREATE = 'PM_LIST_FILTER_CREATE',
  PM_LIST_FILTER_UPDATE = 'PM_LIST_FILTER_UPDATE',
  PM_LIST_FILTER_REMOVE = 'PM_LIST_FILTER_REMOVE',
  PM_LIST_FILTER_INIT = 'PM_LIST_FILTER_INIT',
  PM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS = 'PM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS',
  PM_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES = 'PM_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES',
}
